const Video = (target) => {
  const button = target.querySelector(".video__button");
  const iframe = target.querySelector(".video__iframe");
  const videoSrc = iframe.getAttribute("data-src");

  const method = {
    init: () => {
      if (button) {
        button.addEventListener("click", method.onPlay);
      }
    },
    onPlay: () => {
      iframe.src = videoSrc;
      target.classList.add("video--play");
    },
  };

  method.init();
};

export default Video;
